<template lang="pug">
.mg-item
  img(:src="getPrizeImgSrc")
  .mg-item__info(:name="getTooltipId") i
  .mg-item__amount(v-if="prize.contents[0].amount > 1") {{ prize.contents[0].amount }}

  tippy(:to="getTooltipId", theme="item")
    ItemTooltip(:itemContent="prize.contents[0].content")
</template>

<script>
import ItemTooltip from "@chronos/frontend-base/src/components/tooltip/la/ItemTooltip";
export default {
  name: "PrizeItem",

  components: { ItemTooltip },

  props: {
    prize: Object,
  },

  computed: {
    getPrizeImgSrc() {
      return this.prize.offer.images.preview ? this.prize.offer.images.preview : require(`@/assets/game/images/prizes/default.png`);
    },

    getTooltipId() {
      return `tooltip_${this.prize.offer.name}_${Math.random()}`;
    },
  },
};
</script>
